import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventEmitterService } from '../../services/event-emitter.service';
import { BusinessesService } from '../../services/businesses.service';

@Component({
  standalone: false,
  selector: 'app-business-category-popup',
  templateUrl: './business-category-popup.component.html',
  styleUrl: './business-category-popup.component.scss',
})
export class BusinessCategoryPopupComponent implements OnInit {
  title;
  type = '';
  formGroup: FormGroup;
  category;
  disableButton = false;

  constructor(
    public bsModalRef: BsModalRef,
    private businessesService: BusinessesService,
    private eventEmitterService: EventEmitterService,
  ) {}

  ngOnInit() {
    this.setupForm();
  }

  setupForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(
        this.category ? this.category.name : '',
        Validators.required,
      ),
      emoji: new FormControl(this.category ? this.category.emoji : ''),
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  buttonClicked() {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.invalid) {
      return;
    }

    if (this.disableButton == true) {
      return;
    }
    this.disableButton = true;

    const formValue = { ...this.formGroup.value };

    if (this.type === 'new-business-category') {
      this.businessesService.createBusinessCategory(formValue).subscribe(
        (response) => {
          console.log('response:');
          console.log(response);
          this.eventEmitterService.callAllBusinessCategories();
          this.closeModal();
          this.disableButton = false;
        },
        (error) => {
          console.log('error:');
          console.log(error);
          this.disableButton = false;
        },
      );
    }
    if (this.type === 'edit-business-category') {
      this.businessesService
        .updateBusinessCategory(this.category.id, formValue)
        .subscribe(
          (response) => {
            console.log('response:');
            console.log(response);
            this.eventEmitterService.callAllBusinessCategories();
            this.closeModal();
            this.disableButton = false;
          },
          (error) => {
            console.log('error:');
            console.log(error);
            this.disableButton = false;
          },
        );
    }
  }
}
